import { Card } from 'canoe';
import React from 'react';

import { CreateLocationForm } from './components/CreateLocationForm';
import { Stepper } from './components/Stepper';
import { WizardView } from './components/WizardView';

interface CreateLocationProps {
  onSkip?: () => void;
  onSuccessCreate?: (contentUrl: string) => void;
}

export const CreateLocation = ({ onSuccessCreate, onSkip }: CreateLocationProps) => {
  const onSubmit = (payload: { contentUrl: string }) => {
    onSuccessCreate?.(payload.contentUrl);
  };

  return (
    <Card size="xl">
      <Stepper currentStep={3} />
      <WizardView
        title="Where in your product will this Content go?"
        subTitle="Tell us where in your product you’d like to preview your Content and we’ll grab a Snapshot."
      >
        <CreateLocationForm onSubmit={onSubmit} onSkip={onSkip} />
      </WizardView>
    </Card>
  );
};
